import { fromJS } from 'immutable';

const KEY = [ 'validations', 'referal' ];

export function request(state, { customerId }) {
    return state.setIn([ ...KEY, customerId, 'state' ], 'IN_PROGRESS');
}

export function error(state, { errors, customerId }) {
    return state.setIn([ ...KEY, customerId, 'state' ], 'ERROR')
        .setIn([ ...KEY, customerId, 'errors' ], fromJS(errors));
}

export function finish(state, { validation, customerId }) {
    return state.setIn([ ...KEY, customerId, 'state' ], 'FINISH')
        .setIn([ ...KEY, customerId, 'validation' ], fromJS(validation) );
}
